import React, { useContext, useEffect, useState } from 'react';
import { Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import { useStoreActions, useStoreState } from 'easy-peasy';
import _e from 'common/localeUtil';
import { formatDefaultDateTime, getFullEditingStatus } from '../utils';
import LaunchBrandingDialog from './dialog/LaunchBrandingDialog';
import LaunchSuccessfulDialog from './dialog/LaunchSuccessfulDialog';
import { EditorLeftPanelContext } from './EditorLeftPanelContext';
import PublishSuccessfulDialog from './dialog/PublishSuccessfulDialog';
import { BRANDING_TYPE, REVISION_STATUSES } from '../constants';

const useStyles = makeStyles(theme => ({
	wrapperStyle: {
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1)
	},
	launchSaveButton: {
		fontSize: '0.8rem',
		width: 137,
		borderRadius: 0,
		'&:hover': {
			opacity: 0.8
		},
		minHeight: 32
	},
	launchButton: {
		border: '2px solid rgb(34, 91, 171)'
	},
	saveButton: {
		backgroundColor: '#365275',
		border: 0,
		'&:hover': {
			backgroundColor: '#365275',
			opacity: 0.8
		}
	}
}));

const TemplateRevisionStatusComponent = () => {
	const classes = useStyles();
	const [showLaunchDialog, setShowLaunchDialog] = useState();
	const [showLaunchSuccessDialog, setShowLaunchSuccessDialog] = useState();
	const [showPublishSuccessDialog, setShowPublishSuccessDialog] = useState();
	const template = useStoreState(state => state.template.template);
	const statusData = useStoreState(state => state.template.statusData);
	const loadTemplate = useStoreActions(actions => actions.template.loadTemplate);
	const adviserData = useStoreState(state => state.template.adviserData);

	const context = useContext(EditorLeftPanelContext);
	const { formik } = context;
	// console.log('EditorLeftPanelWebsiteStatus formik', formik);

	if (!window.selectedTemplate) {
		window.selectedTemplate = template;
	}

	useEffect(() => {
		loadTemplate();
	}, []);

	const toggleShowLaunchDialog = () => {
		setShowLaunchDialog(!showLaunchDialog);
	};
	const toggleShowLaunchSuccessDialog = () => {
		console.log('toggleShowLaunchSuccessDialog');
		setShowLaunchSuccessDialog(!showLaunchSuccessDialog);
	};
	const toggleShowPublishSuccessDialog = () => {
		setShowPublishSuccessDialog(!showPublishSuccessDialog);
	};

	const handlePublish = async () => {
		window.gm_track(`Launch or Publish button clicked`);
		if (window.isPB) {
			console.log('BeforePublish');
			formik.setFieldValue('revisionStatus', REVISION_STATUSES.PUBLISHED);
			await formik.submitForm();
			console.log('AfterPublish');
			if (window.currentStatus === REVISION_STATUSES.PUBLISHED) {
				toggleShowPublishSuccessDialog();
			} else {
				toggleShowLaunchSuccessDialog();
			}
		} else {
			toggleShowLaunchDialog();
		}
	};

	const handleSave = () => {
		formik.setFieldValue('revisionStatus', REVISION_STATUSES.DRAFT);
		formik.submitForm();
	};

	const generateStatusBox = () => {
		if (isEmpty(statusData)) return null;
		// console.log('TCL: generateStatusBox', statusData);
		const {
			website_status: websiteStatus = {},
			report_status: reportStatus,
			ebookintro_status: ebookIntroStatus
		} = statusData;

		let classStatusBoxName = 'website-status';
		let statusBoxData = websiteStatus;
		if (window.GM_BRANDING_TYPE === BRANDING_TYPE.TYPE_REPORT_COVER) {
			classStatusBoxName = 'report-status';
			statusBoxData = reportStatus;
		} else if (window.GM_BRANDING_TYPE === BRANDING_TYPE.TYPE_EBOOK_INTRO) {
			classStatusBoxName = 'ebookintro-status';
			statusBoxData = ebookIntroStatus;
		}

		const { status, publishedOn, lastRevisionUpdated } = statusBoxData;
		window.currentStatus = status;
		const websiteStatusFull = getFullEditingStatus(status);

		return (
			<div className={`${classStatusBoxName}`}>
				<div className="row">
					<div className="left">{_e('status')}</div>
					<div className="right">{websiteStatusFull}</div>
				</div>
				{status === REVISION_STATUSES.PUBLISHED && (
					<div className="row">
						<div className="left">{_e('published_on')}</div>
						<div className="right">{formatDefaultDateTime(publishedOn)}</div>
					</div>
				)}
				{status !== REVISION_STATUSES.BLANK && (
					<div className="row">
						<div className="left">{_e('last_updated_on')}</div>
						<div className="right">{formatDefaultDateTime(lastRevisionUpdated)}</div>
					</div>
				)}
			</div>
		);
	};

	const generateWebsiteStatus = () => {
		return (
			<div className={`status-box-wrapper ${classes.wrapperStyle}`}>
				{generateStatusBox()}
				<div className="bottom-row">
					<Button
						onClick={handlePublish}
						className={`button submitButton ${classes.launchSaveButton} ${classes.launchButton}`}
					>
						{window.currentStatus === REVISION_STATUSES.PUBLISHED
							? _e('publish')
							: _e('launch')}
					</Button>
					<Button
						onClick={handleSave}
						className={`button submitButton ${classes.launchSaveButton} ${classes.saveButton}`}
					>
						{_e('save')}
					</Button>
				</div>
				<Box
					className="website-status"
					pt={1}
					pb={1}
					display="flex"
					justifyContent="flex-end"
				>
					<div>{_e('auto_save')}</div>
				</Box>
				{showLaunchDialog && (
					<LaunchBrandingDialog
						open={showLaunchDialog}
						onClose={toggleShowLaunchDialog}
					/>
				)}
				{showLaunchSuccessDialog && (
					<LaunchSuccessfulDialog
						open={showLaunchSuccessDialog}
						handleClose={toggleShowLaunchSuccessDialog}
					/>
				)}
				{showPublishSuccessDialog && (
					<PublishSuccessfulDialog
						open={showPublishSuccessDialog}
						handleClose={toggleShowPublishSuccessDialog}
					/>
				)}
			</div>
		);
	};

	if (!adviserData) {
		return false;
	}
	return <div className={classes.websiteStatusWrapper}>{generateWebsiteStatus()}</div>;
};

TemplateRevisionStatusComponent.propTypes = {};

export default TemplateRevisionStatusComponent;
